import { render } from "./ViewsSurveysDelivery.vue?vue&type=template&id=90bee336"
import script from "./ViewsSurveysDelivery.vue?vue&type=script&lang=js"
export * from "./ViewsSurveysDelivery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__